import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import {DxDataGridModule, DxPopupModule} from 'devextreme-angular';
import {TaskService} from '../../../../services/task-service';
import {LogLevel, TaskDto, TaskLogsDTO} from '../../../../model/Task';
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-task-logs-component',
  imports: [
    DxPopupModule,
    DxDataGridModule,
    DatePipe
  ],
  templateUrl: './task-logs-component.html',
  styleUrl: './task-logs-component.scss'
})
export class TaskLogsComponent implements AfterViewInit {

  @Input() visible!: boolean;
  @Input() task: TaskDto | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() taskChange = new EventEmitter<TaskDto | null>();

  moreLogs?: boolean;
  interval?: number;
  lastTimestamp?: string;

  taskLogs?: TaskLogsDTO;
  readonly LogLevel = LogLevel;

  constructor(private taskService: TaskService){}

  ngAfterViewInit() {
    if(this.task)
      this.taskService.getAllLogs(this.task?.id).subscribe(res => {
        this.taskLogs = res;
        this.moreLogs = res.moreLogs;
        this.lastTimestamp = res.lastTimestamp;

        if (this.moreLogs) {
          this.interval = setInterval(() => this.fetchMore(), 3000);
        }
      });
  }

  fetchMore() {
    if(this.task && this.lastTimestamp) {
        const timestampMillis = new Date(this.lastTimestamp).getTime();
        this.taskService.getLogs(this.task.id, timestampMillis).subscribe(res => {
          this.taskLogs = res;
          this.moreLogs = res.moreLogs;
          this.lastTimestamp = res.lastTimestamp;
          if (!this.moreLogs) {
            clearInterval(this.interval);
          }
        });
    }
  }

  onVisibleChange(newValue: boolean) {
    this.visible = newValue;
    this.visibleChange.emit(this.visible);

    clearInterval(this.interval);

    if(!newValue) {
      this.task = null;
      this.taskChange.emit(null);
    }
  }
}
